export const companyParamKey = 'companyUuid'
export const csParamKey = 'csUuid'
export const invoiceParamKey = 'invoiceUuid'
export const receiptParamKey = 'receiptUuid'
